import { render } from "./CustomTable.vue?vue&type=template&id=d53d33f4&scoped=true"
const script = {}

import "./CustomTable.vue?vue&type=style&index=0&id=d53d33f4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d53d33f4"]])

export default __exports__